import { render, staticRenderFns } from "./GroupMemberListModal.vue?vue&type=template&id=56a32b00"
import script from "./GroupMemberListModal.vue?vue&type=script&lang=js"
export * from "./GroupMemberListModal.vue?vue&type=script&lang=js"
import style0 from "./GroupMemberListModal.vue?vue&type=style&index=0&id=56a32b00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports